
import { CBScaleFix, CBScaleLiner, CBScaleTime } from './cb_scale.js'


let default_chart_options = {
  canvas_size: {
    width: 400,
    height: 300,
  },
  clip_size: {
    width: 400,
    height: 300
  },
  axis_x: {
    style: {
      height: 20
    }
  },
  axes_y: {
  }
}

class CBChart {
  constructor(div_id, data_artists, options) {
    this.container_id = div_id
    this.container = document.getElementById(this.container_id)
    this.options = Object.deepAssign({}, default_chart_options, options)
    this.axis_x = Object.deepAssign({}, this.options.axis_x)
    this.axes_y = Object.deepAssign({}, this.options.axes_y)

    this.init_elems()
    this.assign_data(data_artists)
    this.draw()
  }

  draw() {
    this.draw_axis_x()
    this.draw_axes_y()
    this.draw_data()
  }

  init_elems() {
    console.error("Not Implemented")
    return this
  }

  init_scale_x(data_artists) {
    console.error("Not Implemented")
    return this
  }
  init_scale_y(data_artists) {
    console.error("Not Implemented")
    return this
  }

  assign_data(data_artists) {
    this.init_scale_x(data_artists)
    this.init_scale_y(data_artists)
    this.data_artists = data_artists
    return this
  }

  draw_data() {
    console.error("Not Implemented")
    return this
  }

  draw_axis_x() {
    if (this.axis_x.paint) {
      this.axis_x.paint.draw(this.scale_x)
    }
    return this
  }

  draw_axes_y() {
    for (let elem in this.axes_y) {
      let axis_y = this.axes_y[elem]
      if (axis_y.paint) {
        axis_y.paint.draw(this.scale_y[elem])
      }
    }
    return this
  }

  destroy() {
    if (this.data_artists) {
      for (let elem in this.data_artists) {
        this.data_artists[elem] = this.data_artists[elem].destroy()
      }
      this.data_artists = null
    }

    if (this.axes_y) {
      for (let elem in this.axes_y) {
        if (this.axes_y[elem].paint) {
          this.axes_y[elem].paint.destroy()
        }
      }
    }

    if (this.scale_x) {
      this.scale_x = this.scale_x.destroy()
    }
    if (this.scale_y) {
      for (let elem in this.scale_y) {
        this.scale_y[elem] = this.scale_y[elem].destroy()
      }
      this.scale_y = null
    }

    this.container.innerHTML = ""

    return null
  }
}

/**
 * CBLineChart
 * 不一定要折線圖才能用
 * 只要x, y軸有照順序排列的特性即可
 */
class CBLineChart extends CBChart {
  init_elems() {
    this.clip = document.createElement('div')
    this.clip.className += 'cb_chart_clip'
    this.clip.style.width = css_unit_join(this.options.clip_size.width)
    this.container.appendChild(this.clip)

    this._horizontal_drag(this.clip)

    this.canvas_space = document.createElement('div')
    this.canvas_space.style.position = "relative"
    this.canvas_space.className += 'cb_chart_canvas_space'

    this.clip.appendChild(this.canvas_space)

    this.canvas = document.createElement('canvas')
    this.canvas.id = this.container_id + '_canvas'
    this.canvas.width = this.options.canvas_size.width
    this.canvas.height = this.options.canvas_size.height
    this.canvas.style.display = 'block'

    this.canvas_space.appendChild(this.canvas)

    if (!this.axis_x.canvas_range) {
      this.axis_x.canvas_range = [0, this.canvas.width]
    }

    if (this.axis_x.paint) {
      this.axis_x_space = document.createElement('div')
      this.axis_x_space.className += 'axis_x_space'
      this.axis_x_space.style.width = css_unit_join(this.options.canvas_size.width)
      this.axis_x_space.style.height = css_unit_join(this.axis_x.style.height)

      if (this.axis_x.position === 'top') {
        this.clip.prepend(this.axis_x_space)
      }
      else {
        this.clip.appendChild(this.axis_x_space)
      }

      this.axis_x.paint.set_container(this.axis_x_space)
    }

    // axes_y
    let left_y_axis_space = null, right_y_axis_space = null
    for (let elem in this.axes_y) {
      let axis_y = this.axes_y[elem]
      if (axis_y.paint) {
        if (axis_y.position === 'right') {
          if (right_y_axis_space === null) {
            right_y_axis_space = document.createElement('div')
            right_y_axis_space.className += 'y_axis_space'
            right_y_axis_space.style.width = css_unit_join(axis_y.style.width)
            right_y_axis_space.style.height = css_unit_join(this.options.canvas_size.height)
            this.container.append(right_y_axis_space)
          }
          axis_y.paint.set_container(right_y_axis_space)
        }
        else {
          if (left_y_axis_space === null) {
            left_y_axis_space = document.createElement('div')
            left_y_axis_space.className += 'y_axis_space'
            left_y_axis_space.style.width = css_unit_join(axis_y.style.width)
            left_y_axis_space.style.height = css_unit_join(this.options.canvas_size.height)
            this.container.prepend(left_y_axis_space)
          }
          axis_y.paint.set_container(left_y_axis_space)
        }
      }
    }

    return this
  }

  init_scale_x(data_artists) {
    if (this.scale_x) {
      this.scale_x = this.scale_x.destroy()
    }
    if (!Array.isArray(this.axis_x.data_range)) {
      let min = null
      let max = null
      let desc = false
      let xrange = [0, 0]
      for (let elem in data_artists) {
        if (this.axis_x.data_range == "auto") {
          xrange = datesets[elem].xrange()
        }
        else if (this.axis_x.data_range instanceof Function) {
          xrange = this.axis_x.data_range(datesets[elem].xrange())
        }
        if (xrange[0] > xrange[1]) { desc = true }
        if (min === null || min > xrange[0]) {
          min = xrange[0]
        }
        if (max === null || max < xrange[1]) {
          max = xrange[1]
        }
      }
      if (desc) {
        this.axis_x.data_range = [max, min]
      }
      else {
        this.axis_x.data_range = [min, max]
      }
    }

    this.scale_x = new CBScaleLiner(
      this.axis_x.data_range,
      this.axis_x.canvas_range
    )
    return this
  }

  init_scale_y(data_artists) {
    if (this.scale_y) {
      for (let elem in this.scale_y) {
        this.scale_y[elem] = this.scale_y[elem].destroy()
      }
    }
    this.scale_y = {}
    for (let elem in this.axes_y) {
      if (this.axes_y[elem].hasOwnProperty('data_range') &&
        this.axes_y[elem].hasOwnProperty('canvas_range')) {

        if (this.axes_y[elem].data_range == "auto") {
          this.axes_y[elem].data_range = data_artists[elem].yrange()
        }
        else if (this.axes_y[elem].data_range == "auto_from_zero") {
          this.axes_y[elem].data_range = data_artists[elem].yrange_from_zero()
        }
        else if (this.axes_y[elem].data_range instanceof Function) {
          this.axes_y[elem].data_range = this.axes_y[elem].data_range(data_artists[elem].yrange())
        }

        if (Array.isArray(this.axes_y[elem].canvas_range)) {
          this.scale_y[elem] = new CBScaleLiner(
            this.axes_y[elem].data_range,
            this.axes_y[elem].canvas_range
          )
        }
        else {
          this.scale_y[elem] = new CBScaleFix(
            this.axes_y[elem].data_range,
            this.axes_y[elem].canvas_range
          )
        }
      } else {
        this.scale_y[elem] = new CBScaleFix(
          this.axes_y[elem].data_range,
          this.axes_y[elem].canvas_range
        )
      }
    }
    return this
  }

  draw_data() {
    for (let elem in this.data_artists) {
      this.data_artists[elem].draw(this.canvas, this.scale_x, this.scale_y[elem])
    }
    return this
  }

  _horizontal_drag(target){
    let mouse_start_x = 0
    let origin_scroll_left = 0

    target.addEventListener("mousedown", start);

    function start(event){
        if(event.button == 0){
            mouse_start_x = event.clientX;
            origin_scroll_left = target.scrollLeft;

            document.addEventListener("mousemove", move);
            document.addEventListener("mouseup", stop);
        }
        return false
    }
    function move(event){
        var movement = event.clientX - mouse_start_x;

        target.scrollLeft = origin_scroll_left - movement;

        return false
    }
    function stop(){
        document.removeEventListener("mousemove",move);
        document.removeEventListener("mouseup",stop);
    }
  }
}


class CBTimeChart extends CBLineChart {
  init_scale_x() {
    this.scale_x = new CBScaleTime(
      this.axis_x.data_range, this.axis_x.canvas_range)
    return this
  }
}


export {
  CBLineChart, CBTimeChart
}



// WEBPACK FOOTER //
// ./src/assets/cb/cb-chart/cb_chart.js